import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { HOAProvider } from './contexts/HOAContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HOAProvider>
      <App />
    </HOAProvider>
  </React.StrictMode>
);
